export default __webpack_public_path__ + "static/media/red_5.438319e8.png";